import styled from 'styled-components';
import { ButtonText, ButtonRoundedSmall, H2 } from '@comeon/ui';
import Icon, { ICON_RESPONSIBLE_LINE, ICON_UPLOAD_LINE } from '~/components/icon/index.js';
import { HeadWrapper, SubTitle } from '~/components/misc/section-head.js';
import { LIMITS_REDIRECT_CONFIRM, UPLOAD_DOC_REDIRECT_CONFIRM } from '../utils/constants.js';

const RoundedButtonSecondary = styled(ButtonRoundedSmall)`
	color: rgba(var(--qd-modal-contrast-text), 1);
	background: transparent;
	border: 1px solid ${props => (props.disabled ? 'transparent' : 'var(--button-primary-bg, rgba(var(--primary), 1))')};
`;

const StyledButtonText = styled(ButtonText)`
	color: rgba(var(--qd-modal-cancel-text), 1);
	font: var(--label-regular);
`;

export const QDRGScreen = ({
	addView,
	updateViews,
	isLandscape,
	islugasLimit,
	formattedLimit,
	handleClose,
	translation: t
}) => {
	return (
		<>
			<HeadWrapper padding={isLandscape === 'landscape' ? '0' : '12px'}>
				<Icon className="responsible-icon" type={ICON_RESPONSIBLE_LINE} />
				<H2 data-at="main-title-deposit-limit">
					{islugasLimit ? t.LUGAS_LIMIT_REACHED_TITLE : t.DEPOSIT_LIMITS_TEMPLATE_TITLE}
				</H2>
				<SubTitle dataAt="sub-title-deposit-limit" padding="8px 0">
					{islugasLimit ? t.LUGAS_LIMIT_REACHED_MESSAGE : `${t.SELIMIT_REACHED_MESSAGE} ${formattedLimit}`}
				</SubTitle>
			</HeadWrapper>
			<RoundedButtonSecondary
				smallfont
				onClick={() => updateViews(addView(LIMITS_REDIRECT_CONFIRM))}
				type="submit"
				className="u-relative button u-mb1"
				title="title"
				dataAt="mobile-quick-deposit-update-limits"
			>
				{t.UPDATE_DEPOSIT_LIMIT}
			</RoundedButtonSecondary>

			<StyledButtonText onClick={handleClose}>{t.CANCEL}</StyledButtonText>
		</>
	);
};

export const QDSOWScreen = ({ redirectToSow, isLandscape, handleClose, translation: t }) => {
	return (
		<>
			<HeadWrapper padding={isLandscape === 'landscape' ? '0' : '12px'}>
				<Icon className="responsible-icon" type={ICON_UPLOAD_LINE} />
				<H2 data-at="main-title-deposit-limit">{t.SOW_PAGE_HEADER}</H2>
				<SubTitle dataAt="sub-title-deposit-limit" padding="8px 0">
					{`${t.QD_SOW_MESSAGE}`}
				</SubTitle>
			</HeadWrapper>
			<RoundedButtonSecondary
				smallfont
				onClick={redirectToSow}
				type="submit"
				className="u-relative button u-mb1"
				title="title"
				dataAt="mobile-quick-deposit-upload-documents"
			>
				{t.MOBILE_UPLOAD_DOCUMENTS}
			</RoundedButtonSecondary>
			<StyledButtonText onClick={handleClose}>{t.CANCEL}</StyledButtonText>
		</>
	);
};

export const QDKYCScreen = ({ addView, updateViews, isLandscape, setshowKYCmessage, translation: t }) => {
	return (
		<>
			<HeadWrapper padding={isLandscape === 'landscape' ? '0' : '12px'}>
				<Icon className="upload-icon" type={ICON_UPLOAD_LINE} />
				<H2 data-at="main-title-upload-documents">{t.MOBILE_DEPOSIT_KYC_MESSAGE_NOT_UPLOADED}</H2>
				<SubTitle padding="0" dataAt="sub-title-upload-documents">
					{t.QD_KYC_MESSAGE}
				</SubTitle>
				<SubTitle padding="5px 0" dataAt="sub-title-upload-documents">
					{t.QD_KYC_SUBTITLE_MESSAGE}
				</SubTitle>
			</HeadWrapper>
			<RoundedButtonSecondary
				smallfont
				onClick={() => updateViews(addView(UPLOAD_DOC_REDIRECT_CONFIRM))}
				type="submit"
				className="u-relative button u-mb1"
				title="title"
				dataAt="mobile-quick-deposit-upload-documents"
			>
				{t.MOBILE_UPLOAD_DOCUMENTS_HEAD_TITLE}
			</RoundedButtonSecondary>

			<StyledButtonText onClick={() => setshowKYCmessage(false)}>{t.CANCEL}</StyledButtonText>
		</>
	);
};
